import { DefaultYesNoQuestion } from './registrationProcess.enums';

export const maskEmail = (email: string): string => {
  const atIndex = email.indexOf('@');

  if (atIndex <= 2) {
    return email;
  }

  return email.substring(0, 2) + '*'.repeat(atIndex - 2) + email.slice(atIndex);
};

export const convertToDefaultQuestionValueFromBoolean = (value?: boolean | null) => {
  if (typeof value === 'boolean') {
    return value ? DefaultYesNoQuestion.Yes : DefaultYesNoQuestion.No;
  } else {
    return null;
  }
};

export const convertToBooleanFromDefaultQuestionValue = (value?: DefaultYesNoQuestion | null) => {
  if (value === null) {
    return value;
  } else {
    return value === DefaultYesNoQuestion.Yes ? true : false;
  }
};

export const convertMonetaryToNumber = (value: string | null): number | null => {
  if (!value) {
    return null;
  }

  return Number(value.replace(/[$,]/g, ''));
};

export const validatePercentageOwned = (value: string): string => {
  const percentageOwned = +value;

  if (percentageOwned < 25) {
    return 'Must Not Be Less Than 25%';
  }

  return '';
};
